import React, { FC } from "react";
import { RichTextArea } from "../RichTextArea/RichTextArea";
import classNames from "classnames";

interface ErrorMessageProps {
  message: string;
  className?: string;
  onClose?: () => void;
}

export const ErrorMessage: FC<ErrorMessageProps> = (props) => {
  const { message, className, onClose } = props;

  return (
    <RichTextArea
      content={message}
      className={classNames("ErrorMessage", className)}
      icon="info"
      onClose={onClose}
    />
  );
};
